import axios from "axios";
import * as yup from "yup";
import {buildQuery} from "utils/queryUtils";

let schema = yup.object().shape({
    appVersion: yup.string().test("not-blank", "appVersion.required", (appVersion) => appVersion?.length > 0)
});

export const validateDevice = (device) => {
    return schema.validate(device, {abortEarly: false});
};

export const findDevices = (headers, params) => {
    let query = buildQuery(params, []);
    return axios.get(`${process.env.REACT_APP_ACM_API_URL}/devices${query}`, {
        headers
    })
}

export const createDevice = (headers, data) => {
    return axios.post(`${process.env.REACT_APP_ACM_API_URL}/devices`, data, {
        headers
    })
}

export const updateDevice = (headers, id, data) => {
    return axios.patch(`${process.env.REACT_APP_ACM_API_URL}/devices/${id}`, data, {
        headers
    })
}

export const disableDevice = (headers, id) => {
    return axios.patch(`${process.env.REACT_APP_ACM_API_URL}/devices/${id}/disable`, {
        headers
    });
}
